const Configuration = {
    MAX_ATTACHMENT_SIZE: import.meta.env?.VITE_MAX_ATTACHMENT_SIZE,
    helpDeskURL: import.meta.env?.VITE_HELPDESK_URL,
    backofficeURL: {
        URL: import.meta.env?.VITE_BACKOFFICE_URL
    },
    apiGateway: {
        URL: import.meta.env?.VITE_GW_URL
    },
    clarityProjectId: import.meta.env?.VITE_CLARITY_PROJECT_ID,
    MIN_DIFF_CLOSING: import.meta.env?.VITE_MIN_DIFF_CLOSING,
};
export default Configuration;